import React, { useState } from 'react';
import Text from '../../../../Components/Base/Text/Text';
import Button from '../../../../Components/Button/Button';
import { Theme } from '../../../../Enums/Theme.enum';
import styles from './UserSettingsConnections.module.scss';
import LinkButton from '../../../../Components/Button/LinkButton';
import {
	TokenType,
	useCreateTokenMutation,
	useUserTokensQuery,
} from '../../../../graphql/graphql';
import { useEffectAsync } from '../../../../helpers';
import useApiClient from '../../../Base/Hooks/useApiClient';
import useLoading from '../../../Base/Hooks/useLoading';

interface Props {
	userId: string;
}

const UserSettingsConnections: React.FC<Props> = ({ userId }) => {
	const { displayError } = useApiClient();
	const { isLoading, setIsLoading, RenderLoading } = useLoading();
	const [isCodeDisplayed, setIsCodeDisplayed] = useState(false);
	const [code, setCode] = useState<string | undefined>();
	const [createNewToken] = useCreateTokenMutation();
	const { data, isLoading: isLoadingTokens } = useUserTokensQuery({
		userId,
		type: TokenType.Api,
	});

	const createToken = async () => {
		setIsLoading(true);
		try {
			const response = await createNewToken({
				input: { type: TokenType.Api },
			}).unwrap();
			setCode(response.createToken?.token);
		} catch (e) {
			displayError(e);
		}

		setIsLoading(false);
	};

	useEffectAsync(async () => {
		if (!data) return;

		const token = data?.tokens?.data?.find(item => item?.id)?.token;

		if (token) {
			setCode(token);
			return;
		}

		await createToken();
	}, [data]);

	const copyCode = () => {
		if (!code) {
			return;
		}
		navigator.clipboard.writeText(code);
	};

	if (isLoadingTokens || isLoading) {
		return <RenderLoading />;
	}

	return (
		<div className={styles.wrapper}>
			<Text tx='component.userApiToken.step1' />
			<Text tx='component.userApiToken.step2' />
			<div className={styles.buttonsWrapper}>
				<Button
					title='component.userApiToken.button'
					theme={Theme.GREEN}
					onClick={copyCode}
					className={styles.button}
				/>
				<LinkButton
					title='component.userApiToken.errorText'
					theme={Theme.BLUE}
					onClick={() => setIsCodeDisplayed(!isCodeDisplayed)}
				/>
			</div>
			{isCodeDisplayed && (
				<div className={styles.codeWrapper}>
					<Text
						tx='component.userApiToken.errorDescription'
						className={styles.header}
					/>
					<div className={styles.content}>
						<code>{code}</code>
					</div>
				</div>
			)}
			<div>
				<hr />
				<Text tx='component.apiConnections.manuals' />
				<ul>
					<li>
						<LinkButton
							title='component.apiConnections.pcDoctorManual'
							theme={Theme.BLUE}
							href='https://g2ais-update.cgm.cz/navody/MEDDI/MEDDIxPCDOKTOR-dokumentace.pdf'
						/>
					</li>
					<li>
						<LinkButton
							title='component.apiConnections.medicusManual'
							theme={Theme.BLUE}
							href='https://blog.cgmsvet.cz/medicus-napojeni-na-system-meddi/?at=a7100'
						/>
					</li>
				</ul>
			</div>
		</div>
	);
};

export default UserSettingsConnections;
